import type { Study } from '@bioavail/shared-types';
import { absoluteFExample } from './absoluteF';
import { relativeFExample } from './relativeF';
import { foodEffectExample } from './foodEffect';
import { warningCaseExample } from './warningCase';

export interface ExampleEntry {
  id: string;
  name: string;
  description: string;
  build: () => Study;
}

export const EXAMPLES: ExampleEntry[] = [
  {
    id: 'absolute-f',
    name: 'Absolute F — IV vs Oral',
    description: 'IV reference (100 mg) vs oral test (200 mg). Known-good moderate F.',
    build: absoluteFExample,
  },
  {
    id: 'relative-f',
    name: 'Relative F — Tablet vs Capsule',
    description: 'Two oral arms with unequal doses (50 mg vs 25 mg).',
    build: relativeFExample,
  },
  {
    id: 'food-effect',
    name: 'Food-effect study',
    description: 'Fed vs fasting oral arms — demonstrates food-effect ratios.',
    build: foodEffectExample,
  },
  {
    id: 'warning-case',
    name: 'Warning showcase',
    description: 'Sparse sampling and unit mismatch — triggers validation warnings.',
    build: warningCaseExample,
  },
];

export function getExample(id: string): ExampleEntry | undefined {
  return EXAMPLES.find((e) => e.id === id);
}
